<template>
  <NewAccountErrorTemplate :title="title" :subtitle="subtitle" />
</template>

<script>
import NewAccountErrorTemplate from "@/views/profile/components/NewAccountErrorTemplate";

const TITLE = "Unfortunately you are not able to apply for this role";
const SUBTITLE =
  "Based on your responses to the application questions you do not meet the mandatory requirements for the role";

export default {
  name: "DontMeetRequirements",
  components: {
    NewAccountErrorTemplate
  },
  data() {
    return {
      title: TITLE,
      subtitle: SUBTITLE
    };
  }
};
</script>

<style lang="scss"></style>
